<template>
  <div>
    <table class="pricing-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Quantity</th>
          <th>Price</th>
          <th>Subtotal</th>
        </tr>
      </thead>

      <draggable :list="part.content" element="tbody">

          <tr v-for="(row, index) in part.content" :key="index" v-if="part && part.content" class="tr">

            <template v-if="row.type === 'section-divider'">
              <td colspan="4" class="section-divider">
                <pricing-table-textarea v-model="row.data.title" :state="state"></pricing-table-textarea>

                <span v-if="state === 'editor'" class="delete-row" @click="deleteRow(index)"><i class="icon icon-trash"></i></span>
              </td>
            </template>

            <template v-if="row.type === 'data'">
              <td class="name">
                <pricing-table-textarea v-model="row.data.name" :state="state"></pricing-table-textarea>
              </td>
              <td class="quantity">
                <input type="text" v-model="row.data.quantity" :readonly="state !== 'editor'">
              </td>
              <td class="price">
                <input type="text" v-model="row.data.price" :readonly="state !== 'editor'">
              </td>
              <td class="subtotal">
                {{ row.data.quantity * row.data.price | currency }}
                <span v-if="state === 'editor'" class="delete-row" @click="deleteRow(index)"><i class="icon icon-trash"></i></span>
              </td>
            </template>

          </tr>

      </draggable>

      <tfoot>
        <tr class="subtotal">
          <td colspan="4"><strong>Subtotal:</strong> {{ subtotal | currency }}</td>
        </tr>
        <tr class="total">
          <td colspan="4"><strong>Total:</strong> {{ total | currency }}</td>
        </tr>
      </tfoot>

    </table>
    <button v-if="state === 'editor'" class="button is-primary is-small add-row" @click="addRow()">Add Row</button>
    <button v-if="state === 'editor'" class="button is-primary is-small add-section" @click="addSection()">Add Section</button>
  </div>
</template>

<script>
  import pricingTableTextarea from './pricing-table-textarea.vue';
  import draggable from 'vuedraggable';

  export default {
    props: ['part', 'state'],
    components: {
      draggable,
      pricingTableTextarea
    },
    data() {
      return {
        defaultContent: this.returnDefaultContent()
      }
    },
    mounted() {
      if (!this.part.content) {
        this.part.content = this.defaultContent
      }
    },
    computed: {
      subtotal() {
        let subtotal = 0;
        _.each(this.part.content, function(row) {
          if (row.type === 'data') {
            subtotal += row.data.price * row.data.quantity;
          }
        });
        return subtotal;
      },
      total() {
        return this.subtotal; // NEEDS TAX
      }
    },
    watch: {
      'part': {
        handler() {
          var vm = this;
          //vm.$emit('update', { part: vm.part, value: vm.part.content })
        }
      }
    },
    methods: {
      addRow() {
        this.part.content.push({
          id: this.nextId,
          type: 'data',
          data: {
            name: 'Designer',
            quantity: '150',
            price: '150'
          }
        });
      },
      addSection() {
        this.part.content.push({
          id: this.nextId,
          type: 'section-divider',
          data: {
            title: 'Project Phase 1'
          }
        });
      },
      deleteRow(index) {
        this.part.content.splice(index, 1);
      },
      returnDefaultContent() {
        return [
          {
            id: 0,
            type: 'section-divider',
            data: {
              title: 'Project Phase 1'
            }
          },
          {
            id: 1,
            type: 'data',
            data: {
              name: 'Designer',
              quantity: '150',
              price: '150'
            }
          },
          {
            id: 2,
            type: 'data',
            data: {
              name: 'Developer',
              quantity: '100',
              price: '150'
            }
          },
          {
            id: 3,
            type: 'section-divider',
            data: {
              title: 'Project Phase 2'
            }
          },
          {
            id: 4,
            type: 'data',
            data: {
              name: 'Designer',
              quantity: '80',
              price: '150'
            }
          },
          {
            id: 5,
            type: 'data',
            data: {
              name: 'Developer',
              quantity: '120',
              price: '150'
            }
          }
        ];
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  input {
    border: 0;
  }

  .add-row,
  .add-section {
    margin-top: -58px;
  }

  .delete-row {
    display: none;
    position: absolute;
    right: 115px;
    margin-top: -22px;
    cursor: pointer;
    text-align: center;
    background: $green;
    color: $white;
    width: 25px;
    height: 25px;
    border-radius: 60px;
    &:hover {
      background: darken($green, 10%);
    }
    i {
      font-size: 16px;
      margin-top: 4px;
    }
  }

  // .section-divider .delete-row {
  //   right: 20px;
  //   width: 110px;
  // }

  tbody tr:hover {
    .delete-row {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// pricing-table.vue?4a037d23